import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { UserRole } from '@shared-enums';

import { CookieAuthService } from 'src/app/@shared/storage-variables/cookie-auth.service';

import { MenuService } from '../../layouts/main-layout/services/menu.service';

const DEFAULT_FALLBACK_ROUTE = '/home';
// /home is itself role-guarded (blocked for WAREHOUSE), so it can't double
// as the fallback when it's the route being blocked — that would redirect
// a blocked user back to the same blocked route.
const BLOCKED_HOME_FALLBACK_ROUTE = '/inventory';

/**
 * Blocks navigation to routes whose allowed roles (sourced from
 * ALL_MENU_ITEMS via MenuService) don't include the current user's role.
 * Routes not present in the menu are not guarded here and pass through.
 */
export const roleGuard: CanActivateFn = (route, state) => {
  const menuService = inject(MenuService);
  const cookieAuthService = inject(CookieAuthService);
  const router = inject(Router);

  const routePath = state.url.split('?')[0].split('#')[0];
  const allowedRoles = menuService.getRolesForRoute(routePath);

  if (!allowedRoles) {
    return true;
  }

  const roleId = cookieAuthService.getRolId;
  if (roleId != null && allowedRoles.includes(roleId as UserRole)) {
    return true;
  }

  const fallbackRoute =
    routePath === DEFAULT_FALLBACK_ROUTE
      ? BLOCKED_HOME_FALLBACK_ROUTE
      : DEFAULT_FALLBACK_ROUTE;
  router.navigate([fallbackRoute]);
  return false;
};
